import { getEditingEndUser } from '../../../data/booking/selectors/booking';

function getDefaultValues() {
    return {
        firstName: null,
        lastName: null,
        phoneNumber: null
    };
}

function getValues(state) {
    if (getEditingEndUser(state)) {
        return getEditValues(state);
    }

    return getDefaultValues();
}

function getEditValues(state) {
    const { endUser, clientData } = state.booking.data;
    if (clientData) {

        return {
            ...endUser,
            clientId: clientData.id,
            clientEmail: clientData.mail
        }
    }

    else {
        return{
            ...endUser,
            clientId : null,
            clientEmail : null
        }
    }

}

export {
    getValues
};
